import { getLoggingSettings } from "../../config/logging.config";

let logger={
    log:(...args:any[])=>{
        let logSetting = getLoggingSettings();
        if (logSetting.loggingEnabled) {
            let [first,...rest]=args;
            console.log.apply(null,args); 
            console.log(".......................................");    
        }
    },
    error:(...args:any[])=>{
        let logSetting = getLoggingSettings();
        if (logSetting.loggingEnabled) {
            let [first,...rest]=args;
            console.error(first,rest); 
            console.log(".......................................");    
        }
    },
    table:(val:any)=>{
        let logSetting = getLoggingSettings();
        if (logSetting.loggingEnabled) {
            if (console.table){
                console.table(val);
            }
            console.log(".......................................");
        }
    }
};


export {logger};